import { render, staticRenderFns } from "./HowToPlay.vue?vue&type=template&id=41175f90&scoped=true"
import script from "./HowToPlay.vue?vue&type=script&lang=js"
export * from "./HowToPlay.vue?vue&type=script&lang=js"
import style0 from "./HowToPlay.vue?vue&type=style&index=0&id=41175f90&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/.pnpm/vue-loader@15.11.1_40df3e800382af9a7a59c1fe33ba5098/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "41175f90",
  null
  
)

export default component.exports